
import {defineComponent} from "vue";
import CpsDetailWysiwyg from "@/components/layouts/content-pages/detail/CpsDetailWysiwyg.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default defineComponent({
  name: "NamedPageContent",
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CpsDetailWysiwyg},
  data() {
    return {
      id: ''
    };
  },
});
